import { checkPermissions } from '@sharedInterfaces/IPermissions';
import getBusiness from '@src/APIs/graphQl/Business/getBusiness';
import BusinessPage from '@src/App/Pages/EntityPages/Businesses/BusinessPage/BusinessPage';
import type { AppState } from '@store/store';
import React from 'react';
import { useSelector } from 'react-redux';

import Overlay from '../Overlay/Overlay';
import './BusinessOverlay.css';

interface BusinessOverlayProps {
    businessId: number;
    children: React.ReactNode;
    disabled?: boolean;
}

/**
 * BusinessOverlay component.
 *
 * @param {BusinessOverlayProps} props - The props for the BusinessOverlay component.
 * @returns {JSX.Element}
 */
function BusinessOverlay(props: BusinessOverlayProps) {
    const business = useSelector((state: AppState) => state.businesses.find((b) => b.id === props.businessId));
    const permissions = useSelector((state: AppState) => state.permissions);
    const isAllowed =
        checkPermissions('Companies', 'Retrieve', permissions) ||
        checkPermissions('Companies', 'RetrieveOwn', permissions);
    const disabled = !isAllowed || props.disabled;
    const [error, setError] = React.useState<Error | null>(null);

    return (
        <Overlay
            disabled={disabled}
            triggerItem={props.children}
            loaded={business !== null}
            error={error}
            onFirstOpen={() => {
                getBusiness(props.businessId).catch(setError);
            }}
        >
            {business && <BusinessPage entity={business} inDialog={true} />}
        </Overlay>
    );
}

export default BusinessOverlay;
